import { createSlice } from '@reduxjs/toolkit';
import themeConfig from '../theme.config';

const initialState = {
    theme: localStorage.getItem('theme') || themeConfig.theme,
    menu: themeConfig.menu,
    layout: themeConfig.layout,
    animation: themeConfig.animation,
    navbar: themeConfig.navbar,
    isDarkMode: false,
    sidebar: false,
    semidark: themeConfig.semidark,
    pageTitle: '',
};

const themeConfigSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        toggleTheme(state, { payload }) {
            payload = payload || state.theme; // light | dark
            localStorage.setItem('theme', payload);
            state.theme = payload;
            state.isDarkMode = payload === 'dark';

            if (state.isDarkMode) {
                document.querySelector('body')?.classList.add('dark');
            } else {
                document.querySelector('body')?.classList.remove('dark');
            }
            // Cor da barra de status no app instalado (iOS/Android) = fundo do header.
            document.querySelector('meta[name="theme-color"]')?.setAttribute('content', state.isDarkMode ? '#242424' : '#ffffff');
        },
        toggleSidebar(state) {
            state.sidebar = !state.sidebar;
        },
        setPageTitle(_state, { payload }) {
            document.title = `${payload} | Capital Cloud`;
        },
    },
});

export const { toggleTheme, toggleSidebar, setPageTitle } = themeConfigSlice.actions;

export default themeConfigSlice.reducer;
